import { render } from "./taskPlan.vue?vue&type=template&id=0cb164c1&scoped=true"
import script from "./taskPlan.vue?vue&type=script&lang=js"
export * from "./taskPlan.vue?vue&type=script&lang=js"

import "./taskPlan.vue?vue&type=style&index=0&id=0cb164c1&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb164c1"]])

export default __exports__